import API from '@services/API';
import { setError, startSpinner, stopSpinner } from '../../common/actionCreators';

import { configs } from '@constants/configs/configs';
import { ENROLLMENT_HISTORY_ACTION_TYPES } from '@constants/actionTypes/enrollmentHistoryTypes';

export const setEnrollmentHistoryData = ({ data }) => ({
    type: ENROLLMENT_HISTORY_ACTION_TYPES.GET_ENROLLMENT_HISTORY,
    payload: data,
});

export const setEnrollmentHistoryError = ()=>({
    type: ENROLLMENT_HISTORY_ACTION_TYPES.GET_ENROLLMENT_HISTORY_ERROR,
    payload: 'Cannot get enrollment history',
});

const actions = { setError, startSpinner, stopSpinner };

export const getEnRollmentHistory = (coverageYear) => async dispatch => {
    const url = configs.endpoints.GET_ENROLLMENT_HISTORY.processReplacements({ coverageYear, timestamp: new Date().getTime() });
    const data = await API.getData( url, dispatch, actions );

    if (data) {
        dispatch(setEnrollmentHistoryData({ data }));
    } else {
        dispatch(setEnrollmentHistoryError());
    }
};
